module.exports = __webpack_public_path__ + "img/mini-logo.26c8373e.png";